/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-02-05 15:29:55                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-05 16:08:57                               *
 *****************************************************************************/

/* SUMMARY
  * Components
  * Styles
  * AdminNavLayout: Admin navigation layout
*/

/* Components */
import AdminLeftNav from "../components/leftnav/AdminLeftNav";
import AdminTopNav from "../components/topnav/AdminTopNav";
/***/

/* Styles */
import "./AdminNavLayout.scss";
/***/

/**
* AdminNavLayout: Admin navigation layout
* @param children - Children components
*/
export default function AdminNavLayout({
  children
}: {
  children: React.ReactNode;
}) {
  return (
    <div className="admin-nav-layout">
      <AdminTopNav/>

      <div className="admin-content">
        <AdminLeftNav/>

        <div className="admin-subview">
          {children}
        </div>
      </div>
    </div>
  );
}
/***/
